Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.GraphicsPathWinding = module.exports.default = {
	EVEN_ODD: "evenOdd",
	NON_ZERO: "nonZero"
};